export const handleChangeDataMainPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_MAIN', name, value
});